export enum ModalSize {
  Xs,
  Sm,
  Md,
  Lg,
  Xl
}
